module.exports = __webpack_public_path__ + "static/media/news__game-news.1f26e2bd.jpg";